const COMING_SOON_ITEMS = [
  {
    key: "lead-packages",
    title: "Sell Lead Packages to Your Clients",
    description: "Soon you'll be able to offer curated lead packages directly to your own clients and earn on every package sold.",
  },
  {
    key: "ecommerce-stores",
    title: "Earn by Selling E-Commerce Stores",
    description: "Soon you'll be able to refer and sell done-for-you e-commerce stores, earning commission on every store you place.",
  },
];

export function ComingSoonSection() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="coming-soon-section">
      {COMING_SOON_ITEMS.map((item) => (
        <div key={item.key} className="relative bg-igc-surface border border-igc-gold/10 p-5 opacity-80 overflow-hidden" data-testid={`coming-soon-${item.key}`} title="This feature is planned but not built yet — check back soon.">
          <span className="absolute top-3 right-3 text-[10px] px-2 py-1 tracking-widest uppercase bg-igc-gold/15 text-igc-goldText">Coming Soon</span>
          <p className="text-igc-cream font-serif text-base pr-16">{item.title}</p>
          <p className="text-igc-cream/70 text-xs mt-2">{item.description}</p>
        </div>
      ))}
    </div>
  );
}
